import React, { useEffect, useState } from "react";
import {
  ApiService,
  addDefaultSrc,
  ImgUrl,
  isFeatureEnabled,
} from "../services";
import { useSnackbar } from "react-simple-snackbar";
import { Formik, Form } from "formik";
import * as Yup from "yup";
import FormikControl from "../formikComponents/formikControl";
import GImageEditor from "../gComponents/gImageEditor";
import GButton from "../gComponents/gButton";
import useDataFctory from "../useDataFactory";
import ProductVariants from "../products/productVariants";
import GText from "../gComponents/gText";
import { Delete } from "@material-ui/icons";
import Modal from "react-modal";
import LocalizationForm from "../forms/localizationForm";

export default function ProductCreateForm(props) {
  const [isBtnDisabled, setIsBtnDisabled] = useState(false);
  const [openSnackbar] = useSnackbar();
  const [productImg, setProductImg] = useState([]);
  const [productVariants, setProductVariants] = useState([]);
  const [variantTypeIndex, setVariantTypeIndex] = useState(0);
  const { data: categoriesList } = useDataFctory("product/group", false, {
    store_id: props.storeId,
  });
  const { data: classesData } = useDataFctory("tax_classes", false);
  const [localizationsArray, setLocalizationsArray] = useState([]);
  const [localizationVisible, setLocalizationVisible] = useState(false);

  const initialValues = {
    title: "",
    price: "",
    discount: "",
    unit: "",
    unlimited: "1",
    stock: "0",
    categories: "",
    store_id: props.storeId,
    index: "",
    description: "",
    barcode: "",
    images: [],
    variants: [],
    tax_class_id: "",
  };

  const onSubmit = (values) => {
    setIsBtnDisabled(true);
    values.variants = productVariants;
    values.localizations = localizationsArray;
    console.log(values);
    // return;
    ApiService({ method: "POST", route: "products", body: values }).then(
      (response) => {
        console.log("r" + response.data.status_code);
        if (response.data.status_code === 1) {
          props.setPcvisible(false);
          props.onSubmit();
        }
        setIsBtnDisabled(false);
        openSnackbar(response.data.message);
        return;
      }
    );
  };

  const validationSchema = Yup.object({
    title: Yup.string().required("Required"),
    price: Yup.string().required("Required"),
    unit: Yup.string().required("Required"),
    categories: Yup.string().required("Required"),
  });

  if (props.pcvisible === false) {
    return null;
  }
  return (
    <>
      <div className="modal-header"> Add Product</div>
      <div className="modal-body">
        <Formik
          initialValues={initialValues}
          onSubmit={onSubmit}
          validationSchema={validationSchema}
        >
          {({ values, setFieldValue }) => (
            <Form>
              <GText
                semi
                g2
                text={"Basic Information"}
                style={{ margin: "0 15px" }}
              />
              <FormikControl
                control="input"
                type="text"
                label="Title"
                name="title"
                divstyle={{
                  display: "inline-block",
                  width: "67%",
                  boxSizing: "border-box",
                  verticalAlign: "top",
                }}
              />
              {/* <FormikControl
                  control="input"
                  type="number"
                  label="Price"
                  name="price"
                  min={0}
                  divstyle={{
                    display: "inline-block",
                    width: props.isStockShow === "1" ? "50%" : "100%",
                    boxSizing: "border-box",
                    verticalAlign: "top",
                  }}
                /> */}
              <FormikControl
                control="input"
                type="text"
                label="Price"
                name="price"
                onChange={(event) => {
                  const re = /^[0-9.\b]+$/;
                  if (event.target.value && !re.test(event.target.value)) {
                    return;
                  } else {
                    setFieldValue("price", event.target.value);
                  }
                }}
                divstyle={{
                  display: "inline-block",
                  width: "33%",
                  boxSizing: "border-box",
                  verticalAlign: "top",
                }}
              />
              <FormikControl
                control="input"
                type="text"
                label="Discount (in %)"
                name="discount"
                maxLength={3}
                onChange={(event) => {
                  const re = /^[0-9.\b]+$/;
                  if (event.target.value && !re.test(event.target.value)) {
                    return;
                  } else {
                    setFieldValue("discount", event.target.value);
                  }
                }}
                divstyle={{
                  display: "inline-block",
                  width: "33.3%",
                  boxSizing: "border-box",
                  verticalAlign: "top",
                }}
              />
              <FormikControl
                control="input"
                type="text"
                label="Unit"
                name="unit"
                divstyle={{
                  display: "inline-block",
                  width: props.isStockShow === "1" ? "33.3%" : "100%",
                  boxSizing: "border-box",
                  verticalAlign: "top",
                }}
              />
              <FormikControl
                control="input"
                type="text"
                label="Index"
                name="index"
                divstyle={{
                  display: "inline-block",
                  verticalAlign: "top",
                  boxSizing: "border-box",
                  width: "33.3%",
                }}
              />
              {categoriesList ? (
                <FormikControl
                  control="selectGroup"
                  as="select"
                  label="Category"
                  name="categories"
                  options={categoriesList}
                  key_title="title"
                  key_value="id"
                  divstyle={{
                    display: "inline-block",
                    verticalAlign: "top",
                    boxSizing: "border-box",
                    width: "50%",
                  }}
                />
              ) : (
                ""
              )}
              {props.isBarcodeShow == 1 && (
                <FormikControl
                  control="input"
                  type="text"
                  label="Barcode"
                  name="barcode"
                  divstyle={{
                    display: "inline-block",
                    verticalAlign: "top",
                    boxSizing: "border-box",
                    width: "50%",
                  }}
                />
              )}
              <FormikControl
                control="input"
                as="textarea"
                label="Description"
                name="description"
              />
              {props.isStockShow === "1" && (
                <>
                  {" "}
                  <FormikControl
                    control="toggle"
                    label="Unlimited"
                    isToggled={values.unlimited == "1" ? 1 : 0}
                    name="unlimited"
                    onToggle={() => {
                      let unlimitedVal =
                        values.unlimited === "1" ? true : false;
                      unlimitedVal = !unlimitedVal;
                      unlimitedVal = unlimitedVal === true ? "1" : "0";
                      setFieldValue("unlimited", unlimitedVal);
                    }}
                    style={{ width: "25%", boxSizing: "border-box" }}
                  />
                  {values.unlimited != "1" ? (
                    <FormikControl
                      control="input"
                      type="text"
                      label="Stock"
                      name="stock"
                      divstyle={{
                        display: "inline-block",
                        width: "35%",
                        boxSizing: "border-box",
                      }}
                    />
                  ) : (
                    ""
                  )}
                </>
              )}
              {isFeatureEnabled("tax_class_enabled") ? (
                <FormikControl
                  control="select"
                  as="select"
                  label="Tax Class"
                  name="tax_class_id"
                  placeholder={"Choose Tax Class"}
                  options={classesData}
                  key_title="title"
                  key_value="id"
                  divstyle={{
                    display: "inline-block",
                    verticalAlign: "top",
                    boxSizing: "border-box",
                    width: "40%",
                  }}
                />
              ) : (
                ""
              )}
              {props.settings?.locales &&
                props.settings?.locales.length > 0 && (
                  <div style={{ margin: "15px 15px" }}>
                    <label>Localizations</label>

                    {localizationsArray.length > 0 ? (
                      <GButton
                        variant="linkable"
                        onClick={() => setLocalizationVisible(true)}
                      >
                        {localizationsArray.length} Localizations added
                      </GButton>
                    ) : (
                      <GButton
                        variant="linkable"
                        children="+ Add Localization"
                        onClick={() => setLocalizationVisible(true)}
                      />
                    )}
                  </div>
                )}
              <div style={{ margin: "15px" }}>
                <GText semi g2 text={"Product Images"} />
                {productImg.map((b, ind) => {
                  return (
                    <div
                      style={{ position: "relative", display: "inline-block" }}
                      key={ind}
                    >
                      <img
                        alt=""
                        src={ImgUrl("item") + "/" + b.photo}
                        onError={addDefaultSrc}
                        style={{
                          width: "180px",
                          height: "140px",
                          padding: "5px",
                          border: "1px solid #e2e2e2",
                          objectFit: "cover",
                          margin: "5px",
                        }}
                      />
                      <Delete
                        style={{
                          background: "#000",
                          fontSize: "1rem",
                          color: "#fff",
                          padding: "3px",
                          position: "absolute",
                          right: "10px",
                          top: "10px",
                        }}
                        onClick={(e) => {
                          productImg.splice(ind, 1);
                          setProductImg([...productImg]);
                          values.images = [...productImg];
                        }}
                      />
                    </div>
                  );
                })}

                <GImageEditor
                  onSubmit={(newValue, id, thumb_val) => {
                    setProductImg([
                      ...productImg,
                      { photo: newValue, thumb_photo: thumb_val },
                    ]);
                    values.images = [
                      ...productImg,
                      { photo: newValue, thumb_photo: thumb_val },
                    ];
                  }}
                  id="thumb_photo"
                  image={
                    values.photo ? ImgUrl("item") + "/" + values.photo : ""
                  }
                  type="item"
                  style={{ height: "140px", paddingTop: "50px" }}
                  divstyle={{
                    margin: "0 auto",
                    display: "inline-flex",
                    minWidth: "220px",
                  }}
                />
              </div>
              <div style={{ margin: "15px" }}>
                <GText semi g2 text={"Product Variants"} />
                <div style={{ background: "#f8f9fd", padding: "15px 5px" }}>
                  <ProductVariants
                    setVariantTypeIndex={setVariantTypeIndex}
                    selectedIndex={variantTypeIndex}
                    handleVariantAdd={(index, data) => {
                      setVariantTypeIndex(index);
                      productVariants.push(data);
                    }}
                    handleVariantEdit={(index, data) => {
                      setVariantTypeIndex(index);
                      let selectedInd = productVariants.findIndex(
                        (p) => p.variant_id == data.variant_id
                      );
                      productVariants[selectedInd] = data;
                      setProductVariants([...productVariants]);
                    }}
                    handleVariantRemove={(index, i) => {
                      setVariantTypeIndex(index);
                      console.log(i);
                      productVariants.splice(i, 1);
                      setProductVariants([...productVariants]);
                    }}
                    isVarStockShow={props.isStockShow}
                  />
                </div>
              </div>
              <GButton
                type="submit"
                disabled={isBtnDisabled}
                variant="condensed"
                children="Create"
                style={{ width: "calc(100% - 30px)", margin: "15px" }}
              />
            </Form>
          )}
        </Formik>
      </div>

      <Modal
        isOpen={localizationVisible}
        className="modal modalRight"
        overlayClassName="modal-overlay"
        onRequestClose={() => setLocalizationVisible(false)}
        style={{
          content: {
            width: "600px",
          },
        }}
        contentLabel="Localization Form Modal"
      >
        <LocalizationForm
          localizationVisible={localizationVisible}
          setLocalizationVisible={setLocalizationVisible}
          data={localizationsArray}
          onSubmit={(data) => {
            setLocalizationsArray([...data]);
          }}
          keyArray={
            props.localizableKeys || [
              { title: "Title", value: "title" },
              { title: "Unit", value: "unit" },
            ]
          }
          variables={[]}
        />
      </Modal>
    </>
  );
}
